{
  "title": "Intellect Fortress",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "3rd-level abjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "For the duration, you or one willing creature you can see within range has resistance to psychic damage, as well as advantage on Intelligence, Wisdom, and Charisma saving throws.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, you can target one additional creature for each slot level above 3rd. The creatures must be within 30 feet of each other when you target them.",
    "Spell Lists: Artificer, Bard (Optional), Sorcerer (Optional), Warlock (Optional), Wizard (Optional)"
  ],
  "spellLists": ["artificer", "bard", "eldritch-knight", "sorcerer", "warlock", "wizard"]
}
